<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :custom-on-row-click="goNext"
      :model="model"
      :use-default-action="false"
      :use-select="false"
      entity-name="APIDataAccess"
      icon="mdi-developer-board"
    />
    <v-dialog
      v-model="showDetailInfo"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div>
          <div class="d-flex align-center justify-center">
            <div>
              {{ $t('address_info') }}
            </div>
            <v-spacer />
            <v-btn
              icon
              @click="showDetailInfo = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="mt-2 text-body-1 font-weight-regular">
            <json-viewer
              :value="currentData"
              copyable
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import OperationList from '@/model/dataLayer/api/restaurant/OperationList'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import JsonViewer from 'vue-json-viewer'

export default {
  components: {
    IkDataTable,
    JsonViewer
  },
  data: function () {
    return ({
      currentData: null,
      showDetailInfo: false,
      model: OperationList
    })
  },
  methods: {
    goNext (item) {
      this.currentData = JSON.parse(item.operateData)
      this.showDetailInfo = true
    }
  }
}
</script>
